'use client'

import React, { useCallback } from 'react'

import { Holiday } from '@/src/constants/holidayCalendarConfig'
import { getHolidaySelectionDates } from '@/src/utils/holidayCalendar/getHolidaySelectionDates'
import { IRange } from '@/src/components/desktop/srp/searchHeader/searchModifierInputs/hooks/search-inputs-manager'

import { HolidayCarousel } from './holidayCarousel'

interface HolidayCarouselWrapperProps {
    holidays: Holiday[]
    isRoundTrip: boolean
    onDateClick: (dates: IRange) => void
}

const HolidayCarouselWrapper: React.FC<HolidayCarouselWrapperProps> = ({
    holidays,
    isRoundTrip,
    onDateClick
}) => {
    const handleHolidayClick = useCallback(
        (holiday: Holiday) => {
            const dates = getHolidaySelectionDates(holiday, isRoundTrip)
            onDateClick(dates)
        },
        [isRoundTrip, onDateClick]
    )

    return (
        <HolidayCarousel
            holidays={holidays}
            onHolidayClick={handleHolidayClick}
        />
    )
}

export { HolidayCarouselWrapper }
export default HolidayCarouselWrapper

